import type { UIMessage } from "ai";

const getToolOutput = (part: UIMessage["parts"][number]): object | null =>
  "state" in part && part.state === "output-available" && typeof part.output === "object" && part.output !== null
    ? part.output
    : null;

export const isShownFeedbackRequest = (part: UIMessage["parts"][number]): boolean => {
  const output = getToolOutput(part);
  if (part.type === "tool-requestFeedback") {
    return output !== null && "status" in output && output.status === "shown";
  }
  return (
    part.type === "tool-requestHumanSupport" && output !== null && "feedback" in output && output.feedback === "shown"
  );
};

export const hasHandedOff = (messages: UIMessage[]): boolean =>
  messages.some((message) =>
    message.parts.some((part) => {
      const output = getToolOutput(part);
      return (
        part.type === "tool-requestHumanSupport" &&
        output !== null &&
        "externalId" in output &&
        typeof output.externalId === "string"
      );
    })
  );

export const hasShownFeedbackRequest = (messages: UIMessage[]): boolean =>
  messages.some((message) => message.parts.some(isShownFeedbackRequest));

export const getLatestFeedbackRequestId = (messages: UIMessage[]): string | null => {
  const latest = messages.at(-1);
  const request = latest?.role === "assistant" ? latest.parts.filter(isShownFeedbackRequest).at(-1) : undefined;
  return request && "toolCallId" in request ? request.toolCallId : null;
};
